/**
 * 设置api请求的baseURL
 */
let configs = {
    // 请求协议
    protocol: "https",
    // 请求域名
    host: "api.indracore.com",
    // 基础路径
    basePath: "/api/website/wap",
    // 路由请求域名
    webHost: 'www.indracore.com',
};
export default {
    baseURL: configs.protocol + "://" + configs.host + configs.basePath,
    routerUrl: 'http://' + configs.webHost,
    isDev: false
};



// WEBPACK FOOTER //
// ./src/configs/configs.js